import { render, staticRenderFns } from "./travel1.vue?vue&type=template&id=f9094ce0&"
import script from "./travel1.vue?vue&type=script&lang=js&"
export * from "./travel1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports